import BaseModel from './base_model';
import diningPopup from '../templates/popups/dining';

export default class DiningLocation extends BaseModel {
	/**
	 * Represents a DiningLocation linked to the server API.
	 * @constructor
	 * @param {integer} id - The id of the Rails DiningLocation.
	 */
	constructor(id) {
		super();
		this.id = id;
		this.url = W.api_root + 'dining_locations' + '/' + id + '.json';
		this.key = 'DiningLocation_' + id;
		this.object_type = 'dining';
	}

	setHtmlView() {
		this.htmlView = W.api_root + 'map_objects/' + this.data.map_object.id + '.html';
	}

	popupContent() {
		this.setHtmlView();
		return diningPopup(this);
	}
}
